<template>
	<div class="app-input-wrapper">
		<label @click="focusOnInputEl">
			<div v-if="label" class="app-input-label">
				{{ label }}
				<span v-if="requiredField" class="app-input-required">*</span>
			</div>
			<input
				ref="inputEl"
				v-model.trim="model"
				class="app-input-element"
				:class="{
					'input-valid': !error?.length,
					'input-invalid': error?.length,
					'input-disabled': disabled,
					'input-with-icon': iconName,
				}"
				type="phone"
				:name="name"
				:disabled="disabled"
				:placeholder="placeholder"
				@blur="handleBlur"
				@change="emits('change', $event)"
				@input="emits('input', $event)"
				@focus="handleFocus($event)"
				@paste="onPaste"
			/>

			<Icon v-if="iconName" :name="'local:' + iconName" class="app-input-icon" />
		</label>

		<div class="app-input-error">
			<span v-if="error">{{ error }}</span>
		</div>
	</div>
</template>

<script setup lang="ts">
	import Inputmask from 'inputmask';
	import { ref, useTemplateRef, onMounted } from 'vue';
	import { parsePhoneNumberFromString } from 'libphonenumber-js';

	interface IProps {
		label?: string;
		placeholder?: string;
		name?: string;
		error?: string;
		disabled?: boolean;
		mask?: string;
		focusOnMount?: boolean;
		requiredField?: boolean;
		iconName?: string;
	}

	const props = withDefaults(defineProps<IProps>(), {
		label: '',
		placeholder: '',
		name: '',
		error: undefined,
		disabled: false,
		mask: '+7(9##)-###-##-##',
		requiredField: false,
		iconName: '',
	});

	const model = defineModel<string>({ required: true, default: '' });
	const emits = defineEmits(['blur', 'change', 'input', 'focus']);

	const isFocused = ref(false);
	const inputEl = useTemplateRef('inputEl');

	onMounted(() => {
		if (props.focusOnMount) {
			focusOnInputEl();
		}

		// if (inputEl.value) {
		// 	Inputmask(props.mask).mask(inputEl.value);
		// }
	});

	function handleFocus($event: FocusEvent) {
		if (inputEl.value) {
			Inputmask(props.mask).mask(inputEl.value);
		}
		emits('focus', $event);
		isFocused.value = true;
	}

	function handleBlur($event: FocusEvent) {
		emits('blur', $event);
		isFocused.value = false;
	}

	function focusOnInputEl() {
		inputEl.value?.focus();
	}

	function onPaste(event: ClipboardEvent) {
		const pastedText = event.clipboardData?.getData('text/plain');

		if (!pastedText?.length) return;

		if (
			(pastedText.startsWith('8') || pastedText.startsWith('+7')) &&
			parsePhoneNumberFromString(pastedText, 'RU')?.isValid()
		) {
			model.value = pastedText.substring(1);
		}
	}
</script>

<style scoped lang="scss"></style>
+79022455344
